import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React, { useCallback, useMemo } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import SendFeedback from './feedback';
import ChangeLanguage from './language';
import { OnboardingWhiteLabel } from './OnboardingWhiteLabel';
import ChangePassword from './password';
import ChangeProfile from './profile';
import './style.scss';
import TermsOfUse from './terms';
import TermsOfUseWhiteLabel from './terms-whitelabel';

interface ModalProps {
    content: string;
    handleModalClose?: () => void;
}

const staticModalTypes = [
    Constants.headerMenuOptions.TERMS_OF_USE,
    Constants.headerMenuOptions.PASSWORD_FIRST_TIME,
    Constants.headerMenuOptions.ONBOARDING_WHITELABEL,
];
const passwordModalTypes = [Constants.headerMenuOptions.PASSWORD, Constants.headerMenuOptions.PASSWORD_FIRST_TIME];

const MenuModal = ({ content, handleModalClose }: ModalProps) => {
    const { data: strings, isWhiteLabel, isTotvs } = useSelector((state: ApplicationState) => ({
        data: state.locale.data,
        isWhiteLabel: state.appOrganization.data.isWhiteLabel,
        isTotvs: state.appOrganization.data.isTotvs,
    }));

    const closeModalFunction = useCallback(() => {
        handleModalClose && handleModalClose();
    }, [handleModalClose]);

    const modalTitle = useMemo(() => {
        switch (content) {
            case Constants.headerMenuOptions.PROFILE:
                return strings.CHANGE_PROFILE;
            case Constants.headerMenuOptions.LANGUAGE:
                return strings.CHANGE_LANGUAGE;
            case Constants.headerMenuOptions.FEEDBACK:
                return strings.SEND_FEEDBACK;
            case Constants.headerMenuOptions.TERMS_OF_USE:
                return strings.TERMS_OF_USE;
            case Constants.headerMenuOptions.PASSWORD:
            case Constants.headerMenuOptions.PASSWORD_FIRST_TIME:
                return strings.CHANGE_PASSWORD;
            default:
                return '';
        }
    }, [strings, content]);

    return (
        <Modal
            backdrop={staticModalTypes.includes(content) ? 'static' : undefined}
            centered
            id="change-modal"
            keyboard={!staticModalTypes.includes(content)}
            onHide={handleModalClose}
            show={content !== ''}
        >
            {content !== '' && (
                <div className="change-modal-content modal-content">
                    {content !== Constants.headerMenuOptions.TERMS_OF_USE && (
                        <div className="modal-title">
                            <div className="inner-content">
                                <span className="text-title">{modalTitle}</span>
                            </div>

                            {!staticModalTypes.includes(content) && (
                                <i
                                    className="material-icons-outlined align-middle icon-close"
                                    data-dismiss="modal"
                                    onClick={closeModalFunction}
                                    onKeyDown={() => {}}
                                    role="button"
                                    tabIndex={0}
                                >
                                    close
                                </i>
                            )}
                        </div>
                    )}

                    {content === Constants.headerMenuOptions.PROFILE && <ChangeProfile handleModalClose={handleModalClose} />}
                    {content === Constants.headerMenuOptions.LANGUAGE && <ChangeLanguage handleModalClose={handleModalClose} />}
                    {passwordModalTypes.includes(content) && <ChangePassword handleModalClose={handleModalClose} />}
                    {content === Constants.headerMenuOptions.TERMS_OF_USE && (
                        <div className="modal-terms-of-use">
                            {(isWhiteLabel && <TermsOfUseWhiteLabel handleModalClose={handleModalClose} />) || (
                                <TermsOfUse handleModalClose={handleModalClose} />
                            )}
                        </div>
                    )}
                    {content === Constants.headerMenuOptions.FEEDBACK && <SendFeedback />}
                    {content === Constants.headerMenuOptions.ONBOARDING_WHITELABEL && (
                        <div className="modal-terms-of-use">
                            <OnboardingWhiteLabel handleModalClose={handleModalClose} />
                        </div>
                    )}
                </div>
            )}
        </Modal>
    );
};

export default MenuModal;
